import React from 'react';
import TrialBalance from './Trial_Balance';
import '../../../CommonCSS/SocietyCSS.css'

const TrialBalApp = () => {
  return (

    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Trial Balance</h5>
          </div>
        </div>
        <TrialBalance />
      </div>
    </div >
  );
};

export default TrialBalApp;
